/** Утилиты разбора CSV/TSV для импорта справочников. */

/** Разбор одной строки CSV с поддержкой кавычек и экранированных кавычек. */
export function splitCsvLine(line: string, delimiter: string): string[] {
  const out: string[] = [];
  let cur = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (inQuotes) {
      if (ch === '"') {
        if (line[i + 1] === '"') {
          cur += '"';
          i++;
        } else inQuotes = false;
      } else cur += ch;
    } else if (ch === '"') inQuotes = true;
    else if (ch === delimiter) {
      out.push(cur);
      cur = '';
    } else cur += ch;
  }
  out.push(cur);
  return out;
}

/** Определяет разделитель по первой строке (таб/«;»/«,»). */
export function pickDelimiter(line: string): string {
  if (line.includes('\t')) return '\t';
  if (line.includes(';')) return ';';
  return ',';
}

/** Разбирает текст в матрицу ячеек + выделяет строку-заголовок (если есть). */
export function parseGrid(text: string): { rows: string[][]; header: string[] | null } {
  const clean = text.replace(/^﻿/, '');
  const lines = clean.split(/\r?\n/).filter((l) => l.trim() !== '');
  if (lines.length === 0) return { rows: [], header: null };
  const delimiter = pickDelimiter(lines[0]);
  const grid = lines.map((l) => splitCsvLine(l, delimiter).map((c) => c.trim()));
  // Заголовок: первая ячейка не является кодом (нет цифр).
  const header = grid.length && !/\d/.test(grid[0][0]) ? grid[0] : null;
  const rows = header ? grid.slice(1) : grid;
  return { rows, header };
}

/** Индекс колонки по списку синонимов заголовка (или fallback-позиция). */
export function colIndex(header: string[] | null, aliases: string[], fallback: number): number {
  if (!header) return fallback;
  const lower = header.map((h) => h.toLowerCase());
  for (const a of aliases) {
    const i = lower.indexOf(a);
    if (i >= 0) return i;
  }
  return fallback;
}
